import { Transition } from "@headlessui/react";
import { Suspense } from "react";
import { resolveValue, Toaster } from "react-hot-toast";
import { Outlet } from "react-router-dom";
import useScrollToTop from "../hooks/useScrollToTop";
import Copy from "./Copy";
import Footer from "./Footer";
import Header from "./Header";
import Loader from "./Loader";

const Layout = () => {
  useScrollToTop();

  return (
    <div className="flex flex-col min-h-screen">
      <Header />

      <div className="container grow my-12 px-4 md:my-24 lg:px-24">
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </div>

      <Footer />

      <Copy />

      <Toaster
        position="top-center"
        reverseOrder={false}
        containerStyle={{
          top: "100px",
        }}
      >
        {(t) => {
          let bg = "bg-blue-500";

          if (t.type === "error") {
            bg = "bg-red-500";
          } else if (t.type === "success") {
            bg = "bg-green-500";
          }

          return (
            <Transition
              appear
              show={t.visible}
              className={`${bg} px-4 py-2 shadow-md text-white transform`}
              enter="transition-all duration-150"
              enterFrom="opacity-0 scale-50"
              enterTo="opacity-100 scale-100"
              leave="transition-all duration-150"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-75"
            >
              {resolveValue(t.message, t)}
            </Transition>
          );
        }}
      </Toaster>
    </div>
  );
};

export default Layout;
